// extracted by mini-css-extract-plugin
export default {"invalid":"InvalidPage_invalid__cY8bc"};